import React from "react";

import CommonModal from "../../../Components/Modal";
import Table from "../../../Components/Table";
import "./style.scss";

interface DataModalProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  data: any[];
  columns: any[];
}

const DataModal: React.FC<DataModalProps> = ({
  isOpen,
  toggle,
  title,
  data,
  columns,
}) => {
  return (
    <CommonModal isOpen={isOpen} toggle={toggle} title={title} size="4xl">
      <div className="data-modal">
        <Table columns={columns} data={data} />
      </div>
    </CommonModal>
  );
};

export default DataModal;
